import { computed, ref } from 'vue'

export function useScrollLock() {
  const scrollLock = ref(false)
  const body = document.body

  function lock() {
    body.style.overflow = 'hidden'
    scrollLock.value = true
  }

  function unlock() {
    body.style.overflow = ''
    scrollLock.value = false
  }

  function toggle() {
    if (scrollLock.value) {
      unlock()
      return
    }

    lock()
  }

  return {
    scrollLock: computed(() => scrollLock.value),
    lock,
    unlock,
    toggle,
  }
}
